<template>
  <div class="visa-dialog-modal">
    <el-dialog
      :visible.sync="visible"
      :size="size"
      :show-close="false"
      :custom-class="widthClass"
      :top="top"
      :close-on-click-modal="closeOnClickModal">
      <!-- 头部 -->
      <div class="custom-header">
        {{titleInfo}}
        <!-- 关闭 -->
        <div class="el-dialog__headerbtn" @click="closeModal" v-if="showClose">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <slot></slot>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'visa-dialog-modal',
  components: {
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: true,
    },
    size: {
      type: String,
      default: 'small',
    },
    widthClass: {
      type: String,
    },
    titleInfo: {
      type: String,
      default: '',
    },
    closeOnClickModal: {
      type: Boolean,
      default: true,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    top: {
      type: String,
      default: '30%',
    },
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit('visibleSync', newValue);
      },
    },
  },
  methods: {
    // 关闭对话框回调
    closeModal() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less">
@import "../../../../assets/less/variable";

.visa-dialog-modal {
  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog--small{
    .custom-header{
      height: 50px;
      display: block;
      padding: 0 20px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-bottom: 1px solid #f0f0f0;
      font-size: 16px;
      color: #333333;
      .el-dialog__close {
        position: absolute;
        right: 20px;
        top: 16px;
        width: 19px;
        height: 19px;
        transform: rotateZ(45deg);
        cursor: pointer;

        &::before {
          content: "";
          display: block;
          width: 19px;
          position: absolute;
          top: 9px;
          left: 0;
          border-top: 1px solid #777;
        }

        &::after {
          content: "";
          display: block;
          height: 19px;
          position: absolute;
          top: 0;
          left: 9px;
          border-left: 1px solid #777;
        }

        &:hover {
          &::before,
          &::after {
            border-color: @main;
          }
        }
      }
    }
  }

  .width757{
    width: 757px;
  }

  .width420{
    width: 420px;
  }

  .width400{
    width: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/modals/visa-dialog/visa-dialog.vue